export default __webpack_public_path__ + "static/media/ai-star-grey-border.44221537.svg";